import { InfoIcon } from "lucide-react";

import {
  TelegramLoginButton,
  CreateTelegramUser,
} from "@/components/socials/telegram-login-button";

interface TelegramLinkNoticeProps {
  onAuth: (user: CreateTelegramUser) => void;
  botName: string;
}

export const TelegramLinkNotice = ({
  onAuth,
  botName,
}: TelegramLinkNoticeProps) => (
  <div className="bg-white border-2 border-swapper-primary/20 rounded-2xl p-4 md:p-6 shadow-lg">
    <div className="flex items-start gap-3">
      <InfoIcon className="w-5 h-5 text-swapper-primary flex-shrink-0 mt-0.5" />
      <div className="space-y-3">
        <div className="space-y-1.5">
          <h3 className="font-bold text-swapper-secondary">Connect your Telegram account</h3>
          <p className="text-sm text-swapper-secondary/70 leading-relaxed">
            To complete Telegram-related tasks, you need to connect your
            Telegram account first. This helps us verify your social actions.
          </p>
        </div>

        <div className="[&>iframe]:!w-auto [&>iframe]:!h-8 [&>iframe]:!rounded-full">
          <TelegramLoginButton
            botName={botName}
            buttonSize="small"
            dataOnauth={onAuth}
            cornerRadius={20}
            requestAccess
          />
        </div>
      </div>
    </div>
  </div>
);
